import { useState } from "react";
import api from "api/api";

//Props Validations
import PropTypes from "prop-types";

// redux
import { useSelector } from "react-redux";

//Material UI Components
import Dialog from "@mui/material/Dialog";
import DialogContent from "@mui/material/DialogContent";
import DialogTitle from "@mui/material/DialogTitle";
import { TextareaAutosize } from "@mui/material";
import Button from "@mui/material/Button";

//Material UI Icons
import IosShareIcon from "@mui/icons-material/IosShare";

import ImageMagnifier from "./ImageMagnifier";
import Loader from "./Loader";

import { useDispatch } from "react-redux";
import { showNotification } from "store/features/notificationSlice";

const deoProductDetails = [
    ["Brand", "brand"],
    ["Product Name", "product_code"],
    ["Format", "format_data"],
    ["Study Reference", "study_reference__title"],
    ["Study Period", "study_period__title"],
    ["Sharepoint Link", "share_point_link"],
    ["Fragrance", "fragrance"],
    ["Fragrance Level", "fragrance_level"],
    ["Ingredients list", "ingredients_list"],
    ["Packaging Body Common Name", "packaging_body_common_name"],
    ["Packaging Body Name", "packaging_body_name"],
    ["Packaging Size", "packaging_size_value"],
    ["Packaging Size Unit", "packaging_size_unit"],
    ["Chassis", "chassis"],
    ["Antiperspirant Active", "antiperspirant_active"],
    ["Antiperspirant Active Level", "antiperspirant_active_level"],
    ["Encaps", "encaps"],
    ["Encaps Level", "encaps_level"],
    ["Packaging Actuator Common Name", "packaging_actuator_common_name"],
    ["Packaging Actuator", "packaging_actuator"],
    ["Packaging Valve", "packaging_valve"],
    ["Product Identifier PLM", "product_identifier_plm"],
    ["Product Identifier LIMS", "product_identifier_lims"],
    ["Product Superiority DEO code", "product_superiority_deo_code"],
    ["PC Family Primary Descriptor", "pc_family_primary_descriptor"],
    ["PC Family Secondary Descriptor", "pc_family_secondary_descriptor"],
    ["PC Family Identifier Descriptor", "pc_family_identifier_descriptor"],
    ["Competitor Code", "competitor_code"],
];

const oralCareProductDetails = [
    ["Product Code", "product_code"],
    ["Brand", "brand"],
    ["Format", "format_data"],
    ["Study Reference", "study_reference__title"],
    ["Study Period", "study_period__title"],
    ["Share Point Link", "share_point_link"],
    ["Flavour Name", "flavour_name"],
    ["Flavour Dosage Level", "flavour_dosage_level"],
    ["Flavour House Name", "flavour_house_name"],
    ["Sorbitol Level", "sorbitol_level"],
    ["Saccarine Level", "saccarine_level"],
    ["Ingredients List", "ingredients_list"],
    ["Tube Type", "tube_type"],
    ["Carton Type", "carton_type"],
    ["Tube Cap Type", "tube_cap_type"],
    ["Pack Size Tested", "pack_size_tested"],
    ["Type of Chassis", "type_of_chassis"],
    ["Sensory ID", "sensory_id"],
    ["Product Identifier PLM", "product_identifier_plm"],
    ["Product Identifier LIMS", "product_identifier_lims"],
    ["Primary Claim", "primary_claim"],
];

const SkinCleansingProductDetails = [
    ["Brand", "brand"],
    ["Product Name", "product_code"],
    ["Format", "format_data"],
    ["Study Reference", "study_reference__title"],
    ["Study Period", "study_period__title"],
    ["Sharepoint Link", "share_point_link"],
    ["Fragrance", "fragrance"],
    ["Fragrance Level", "fragrance_level"],
    ["Fragrance Technology", "fragrance_technology"],
    ["Ingredients list", "ingredients_list"],
    ["Starch Level", "starch_level"],
    ["% Total AD", "percentage_total_ad"],
    ["% Glycerin", "percentage_glycerin"],
    ["Packaging Size Unit", "packaging_size_unit"],
    ["Chassis", "chassis"],
    ["TFM", "tfm"],
    ["BLEND", "blend"],
    ["12 Hydroxy Stearic Acid", "twelve_hydroxy_stearic_acid"],
    ["Noodle", "noodle"],
    ["Colour", "colour"],
    ["Product Identifier PLM", "product_identifier_plm"],
    ["Product Identifier LIMS", "product_identifier_lims"],
    ["Competitor Code", "competitor_code"],
];

const hairCareProductDetails = [
    ["Brand", "brand"],
    ["Product Name", "product_code"],
    ["Format", "format_data"],
    ["Study Reference", "study_reference__title"],
    ["Study Period", "study_period__title"],
    ["Share Point Link", "share_point_link"],
    ["No. of products", "number_of_products"],
    ["Fragrance Name", "fragrance_name"],
    ["Fragrance dosage level", "fragrance_dosage_level"],
    ["Colour", "colour"],
    ["Mica/pearl level", "mica_pearl_level"],
    ["Ingredients list", "ingredients_list"],
    ["Type of Chassis", "type_of_chassis"],
    ["Sensory ID", "sensory_id"],
    ["Product Identifier PLM", "product_identifier_plm"],
    ["Product Identifier LIMS", "product_identifier_lims"],
];

const skinCareProductDetails = [
    ["Brand", "brand"],
    ["Product Name", "product_code"],
    ["Format", "format_data"],
    ["Study Reference", "study_reference__title"],
    ["Study Period", "study_period__title"],
    ["Share Point Link", "share_point_link"],
    ["Product Identifier PLM", "product_identifier_plm"],
    ["Product Identifier LIMS", "product_identifier_lims"],
    ["Ingredient list", "ingredient_list"],
    ["Packaging Type", "packaging_type"],
    ["Product Color", "product_color"],
];

const fragranceHouseProductDetails = [
    ["Product Name", "product_code"],
    ["Fragrance", "fragrance"],
    ["Fragrance Level", "fragrance_level"],
    ["Ingredients List", "ingredients_list"],
    ["Packaging Body Common Name", "packaging_body_common_name"],
    ["Packaging Body Name", "packaging_body_name"],
    ["Packaging Size Value", "packaging_size_value"],
    ["Packaging Size Unit", "packaging_size_unit"],
    ["Chassis", "chassis"],
    ["Antiperspirant Active", "antiperspirant_active"],
    ["Antiperspirant Active Level", "antiperspirant_active_level"],
    ["Encaps", "encaps"],
    ["Encaps Level", "encaps_level"],
    ["Packaging Actuator Common Name", "packaging_actuator_common_name"],
    ["Packaging Actuator", "packaging_actuator"],
    ["Packaging Valve", "packaging_valve"],
    ["Product Identifier PLM", "product_identifier_plm"],
    ["Product Identifier LIMS", "product_identifier_lims"],
    ["Product Superiority DEO Code", "product_superiority_deo_code"],
    ["PC Family Primary Descriptor", "pc_family_primary_descriptor"],
    ["PC Family Secondary Descriptor", "pc_family_secondary_descriptor"],
    ["PC Family Identifier Descriptor", "pc_family_identifier_descriptor"],
    ["Competitor Code", "competitor_code"],
    ["% Glycerin", "percentage_glycerin"],
    ["% Total AD", "percentage_total_ad"],
    ["12 Hydroxy Stearic Acid", "hydroxy_stearic_acid_12"],
    ["BLEND", "blend"],
    ["Carton Type", "carton_type"],
    ["Colour", "colour"],
    ["Flavour Dosage Level", "flavour_dosage_level"],
    ["Flavour House Name", "flavour_house_name"],
    ["Flavour Name", "flavour_name"],
    ["Fragrance Dosage Level", "fragrance_dosage_level"],
    ["Fragrance Name", "fragrance_name"],
    ["Fragrance Technology", "fragrance_technology"],
    ["Ingredient List", "ingredient_list"],
    ["Mica/Pearl Level", "mica_pearl_level"],
    ["No. of Products", "no_of_products"],
    ["Noodle", "noodle"],
    ["Pack Size Tested", "pack_size_tested"],
    ["Packaging Type", "packaging_type"],
    ["Primary Claim", "primary_claim"],
    ["Product Color", "product_color"],
    ["Saccarine Level", "saccarine_level"],
    ["Sensory ID", "sensory_id"],
    ["Sorbitol Level", "sorbitol_level"],
    ["Starch Level", "starch_level"],
    ["TFM", "tfm"],
    ["Tube Cap Type", "tube_cap_type"],
    ["Tube Type", "tube_type"],
    ["Type of Chassis", "type_of_chassis"],
    ["Ucode", "ucode"],
    ["Briefing ID", "briefing_id"],
    ["Project Code", "project_code"],
    ["Base Batch LIMS Code", "base_batch_lims_code"],
    ["CTI Masked Code", "cti_masked_code"],
    ["Fragrance ID 1", "fragrance_id_1"],
    ["Fragrance ID 2", "fragrance_id_2"],
];

const ufhTextareaFields = [
    "encaps_level",
    "blend",
    "colour",
    "flavour_name",
    "fragrance_name",
    "fragrance_technology",
    "ingredient_list",
    "mica_pearl_level",
    "noodle",
    "pack_size_tested",
    "packaging_type",
    "primary_claim",
    "product_color",
    "tfm"
];

const otherCategoryTextareaFields = ["ingredients_list", "packaging_body_name", "packaging_valve", "type_of_chassis"];

function ProductDetails({ open = false, closeBtn = <></>, productData = {}, coreDataId = null, selectedProductImage = "", selectedProductImageData = {}, isEdit = false, setSelectedProductData = () => {}, setSelectedProductImageData = () => {}, handleProductDetailsDialogue = () => {} }) {
    const dispatch = useDispatch();
    //loader variables
    const [isLoading, setIsLoading] = useState(false);
    const [loaderMessage, setLoaderMessage] = useState("Uploading");

    const productsSecondaryDataState = useSelector((state) => state.analysisResultsStore.agreementAnalysisResult);
    const secondaryData = productsSecondaryDataState.find((item) => item.title === productData.product_code);
    const productCategoryData = useSelector((state) => state.settingsStore.productCategory);

    const isDeodorants = process.env?.REACT_APP_DEODORANTS?.toLowerCase() === productCategoryData?.label?.toLowerCase();
    const isOralCare = process.env?.REACT_APP_ORAL_CARE?.toLowerCase() === productCategoryData?.label?.toLowerCase();
    const isSkinCleansing = process.env?.REACT_APP_SKIN_CLEANSING?.toLowerCase() === productCategoryData?.label?.toLowerCase();
    const isHairCare = process.env?.REACT_APP_HAIR_CARE?.toLowerCase() === productCategoryData?.label?.toLowerCase();
    const isSkinCare = process.env?.REACT_APP_SKIN_CARE?.toLowerCase() === productCategoryData?.label?.toLowerCase();
    const isUnileverFragranceHouse = process.env?.REACT_APP_UNILEVER_FRAGRANCE_HOUSE?.toLowerCase() === productCategoryData?.label?.toLowerCase();

    const textareaFields = isUnileverFragranceHouse
        ? ufhTextareaFields
        : otherCategoryTextareaFields;

    const handleError = (type, error) => {
        dispatch(showNotification({ severity: type, data: error }));
    };
    const handleInputChange = (value, key) => {
        setSelectedProductData((prev) => {
            return {
                ...prev,
                [key]: value,
            };
        });
    };

    const handleFileChange = (event) => {
        if (event.target.files[0].size <= 1048576) {
            const uploadedImage = event.target.files[0];
            const uploadedImageTitle = Date.now() + event.target.files[0].name.replace(/\s/g, "");

            setSelectedProductImageData((prev) => {
                return {
                    ...prev,
                    imagePath: URL.createObjectURL(uploadedImage),
                    imageData: uploadedImage,
                    imageTitle: uploadedImageTitle,
                };
            });
        } else {
            handleError("error", "Max size limit 1MB");
        }
    };

    const returnEditData = () => {
        let proDetails;
        if (isDeodorants) {
            proDetails = deoProductDetails;
        } else if (isOralCare) {
            proDetails = oralCareProductDetails;
        } else if (isSkinCleansing) {
            proDetails = SkinCleansingProductDetails;
        } else if (isHairCare) {
            proDetails = hairCareProductDetails;
        } else if (isSkinCare) {
            proDetails = skinCareProductDetails;
        } else if (isUnileverFragranceHouse) {
            proDetails = fragranceHouseProductDetails;
        }

        const html = proDetails.map((row, i) => {
            const label = row[0];
            const key = row[1];
            let value = productData[key] ? productData[key] : "";
            const isTextareaField = textareaFields.includes(key);
            const isReadOnly = label === "Study Reference" || label === "Product Name";

            if (label === "Brand" || label === "Format" || label === "Study Period" || label === "Sharepoint Link") {
                return null;
            }

            const uniquekey = `${label}-${i}`;
            return (
                <div
                    key={uniquekey}
                    className="product-details-input-labels-container"
                >
                    <label
                        htmlFor={key}
                        className="product-details-label"
                    >
                        {label}:
                    </label>
                    {isTextareaField ? (
                        <TextareaAutosize
                            placeholder={label}
                            value={value}
                            onChange={(e) => handleInputChange(e.target.value, key)}
                            minRows={1}
                            style={{
                                color: "#424242d4",
                                width: "70%",
                                fontSize: "13px",
                                padding: "1px 10px",
                                borderRadius: "3px",
                                border: "1px solid #49505772",
                            }}
                        />
                    ) : (
                        <input
                            readOnly={isReadOnly && "readonly"}
                            type="text"
                            placeholder={label}
                            value={value}
                            onChange={(e) => handleInputChange(e.target.value, key)}
                        />
                    )}
                </div>
            );
        });

        return html;
    };

    const returnDeoData = () => {
        const html = deoProductDetails.map((row, i) => {
            const label = row[0];
            const key = row[1];

            if (label === "Competitor Code" && !secondaryData?.isCompetitorProduct) {
                return null;
            }

            let value = productData[key] ? productData[key] : "";

            if (label === "Study Period" && value) {
                // Convert from 'YYYY/MM' to 'MM/YYYY'
                const [year, month] = value.split("/");
                value = `${month}/${year}`;
            }

            if (label === "Packaging Size") {
                const unit = productData["packaging_size_unit"] || "";
                value = `${value} ${unit}`;
            } else if (label === "Packaging Size Unit") {
                return null;
            }

            // Check if the value is in exponential notation
            const isExponential = /\d+\.?\d*e[+-]?\d+/i.test(value);
            if (isExponential) {
                value = parseFloat(value).toFixed(5);
            }

            // Determine if the field should use a textarea instead of an input
            const isTextareaField = textareaFields.includes(key);
            return (
                <div
                    key={i}
                    className="product-details-input-labels-container"
                >
                    <label
                        htmlFor={key}
                        className="product-details-label"
                    >
                        {label}:
                    </label>
                    {key === "share_point_link" ? (
                        <a
                            href={productData["share_point_link"]}
                            target="_blank"
                            rel="noopener noreferrer"
                            style={{
                                whiteSpace: "nowrap",
                                overflow: "hidden",
                                textOverflow: "ellipsis",
                                display: "inline-block",
                            }}
                        >
                            {productData["share_point_link"]}
                        </a>
                    ) : isTextareaField ? (
                        <p>{value}</p>
                    ) : (
                        <input
                            readOnly="readonly"
                            type="text"
                            name="sharepointLink"
                            // placeholder={label}
                            // value={value}
                            value={value}
                        />
                    )}
                </div>
            );
        });
        return html;
    };

    const returnOralCareData = () => {
        const html = oralCareProductDetails.map((row, i) => {
            const label = row[0];
            const key = row[1];

            let value = productData[key] ? productData[key] : "";

            // Check if the value is in exponential notation
            const isExponential = /\d+\.?\d*e[+-]?\d+/i.test(value);
            if (isExponential) {
                value = parseFloat(value).toFixed(5);
            }

            const isTextareaField = textareaFields.includes(key);

            return (
                <div
                    key={i}
                    className="product-details-input-labels-container"
                >
                    <label
                        htmlFor={key}
                        className="product-details-label"
                    >
                        {label}:
                    </label>
                    {isTextareaField ? (
                        <p>{value}</p>
                    ) : (
                        <input
                            readOnly="readonly"
                            type="text"
                            value={value}
                        />
                    )}
                </div>
            );
        });
        return html;
    };

    const returnSkinCleansingData = () => {
        const html = SkinCleansingProductDetails.map((row, i) => {
            const label = row[0];
            const key = row[1];

            let value = productData[key] ? productData[key] : "";

            // Check if the value is in exponential notation
            const isExponential = /\d+\.?\d*e[+-]?\d+/i.test(value);
            if (isExponential) {
                value = parseFloat(value).toFixed(5);
            }

            const isTextareaField = textareaFields.includes(key);
            const uniqueKey = `field_${i}`;

            return (
                <div
                    key={uniqueKey}
                    className="product-details-input-labels-container"
                >
                    <label
                        htmlFor={key}
                        className="product-details-label"
                    >
                        {label}:
                    </label>
                    {isTextareaField ? (
                        <p>{value}</p>
                    ) : (
                        <input
                            readOnly="readonly"
                            type="text"
                            value={value}
                        />
                    )}
                </div>
            );
        });
        return html;
    };

    const returnHairCareData = () => {
        const html = hairCareProductDetails.map((row, i) => {
            const label = row[0];
            const key = row[1];

            let value = productData[key] ? productData[key] : "";

            // Check if the value is in exponential notation
            const isExponential = /\d+\.?\d*e[+-]?\d+/i.test(value);
            if (isExponential) {
                value = parseFloat(value).toFixed(5);
            }

            const isTextareaField = textareaFields.includes(key);

            return (
                <div
                    key={i}
                    className="product-details-input-labels-container"
                >
                    <label
                        htmlFor={key}
                        className="product-details-label"
                    >
                        {label}:
                    </label>
                    {key === "share_point_link" ? (
                        <a
                            href={productData["share_point_link"]}
                            target="_blank"
                            rel="noopener noreferrer"
                            style={{
                                whiteSpace: "nowrap",
                                overflow: "hidden",
                                textOverflow: "ellipsis",
                                display: "inline-block",
                            }}
                        >
                            {productData["share_point_link"]}
                        </a>
                    ) : isTextareaField ? (
                        <p>{value}</p>
                    ) : (
                        <input
                            readOnly="readonly"
                            type="text"
                            value={value}
                        />
                    )}
                </div>
            );
        });
        return html;
    };

    const returnSkinCareData = () => {
        const html = skinCareProductDetails.map((row, i) => {
            const label = row[0];
            const key = row[1];

            let value = productData[key] ? productData[key] : "";

            // Check if the value is in exponential notation
            const isExponential = /\d+\.?\d*e[+-]?\d+/i.test(value);
            if (isExponential) {
                value = parseFloat(value).toFixed(5);
            }

            const isTextareaField = textareaFields.includes(key);

            return (
                <div
                    key={i}
                    className="product-details-input-labels-container"
                >
                    <label
                        htmlFor={key}
                        className="product-details-label"
                    >
                        {label}:
                    </label>
                    {key === "share_point_link" ? (
                        <a
                            href={productData["share_point_link"]}
                            target="_blank"
                            rel="noopener noreferrer"
                            style={{
                                whiteSpace: "nowrap",
                                overflow: "hidden",
                                textOverflow: "ellipsis",
                                display: "inline-block",
                            }}
                        >
                            {productData["share_point_link"]}
                        </a>
                    ) : isTextareaField ? (
                        <p>{value}</p>
                    ) : (
                        <input
                            readOnly="readonly"
                            type="text"
                            value={value}
                        />
                    )}
                </div>
            );
        });
        return html;
    };

    const returnUnileverFragranceHouseData = () => {
        const html = fragranceHouseProductDetails.map((row, i) => {
            const label = row[0];
            const key = row[1];

            let value = productData[key] ? productData[key] : "";

            // Check if the value is in exponential notation
            const isExponential = /\d+\.?\d*e[+-]?\d+/i.test(value);
            if (isExponential) {
                value = parseFloat(value).toFixed(5);
            }

            const isTextareaField = textareaFields.includes(key);

            return (
                <div
                    key={i}
                    className="product-details-input-labels-container"
                >
                    <label
                        htmlFor={key}
                        className="product-details-label"
                    >
                        {label}:
                    </label>
                    {key === "share_point_link" ? (
                        <a
                            href={productData["share_point_link"]}
                            target="_blank"
                            rel="noopener noreferrer"
                            style={{
                                whiteSpace: "nowrap",
                                overflow: "hidden",
                                textOverflow: "ellipsis",
                                display: "inline-block",
                            }}
                        >
                            {productData["share_point_link"]}
                        </a>
                    ) : isTextareaField ? (
                        <p>{value}</p>
                    ) : (
                        <input
                            readOnly="readonly"
                            type="text"
                            value={value}
                        />
                    )}
                </div>
            );
        });
        return html;
    };

    const submitProductImage = async () => {
        if (selectedProductImageData) {
            try {
                if (selectedProductImageData.id === undefined) {
                    setLoaderMessage("Uploading");
                    setIsLoading(true);
                    const url = process.env.REACT_APP_SERVER_PATH + `/product-images/`;
                    const formData = new FormData();

                    formData.append("product_images", selectedProductImageData.imageData);
                    formData.append("title", selectedProductImageData.productCode);
                    formData.append("description", selectedProductImageData.imageTitle);
                    formData.append("core_data_model", coreDataId);

                    const config = {
                        headers: {
                            "content-type": "multipart/form-data",
                        },
                    };
                    await api
                        .post(url, formData, config)
                        .then(async () => {
                            setSelectedProductImageData([]);
                            setIsLoading(false);
                            handleProductDetailsDialogue();
                        })
                        .catch((error) => {
                            setIsLoading(false);
                            handleError("error", error);
                        });
                } else {
                    setLoaderMessage("Uploading");
                    setIsLoading(true);
                    const formData = new FormData();

                    formData.append("product_images", selectedProductImageData.imageData);

                    const config = {
                        headers: {
                            "content-type": "multipart/form-data",
                        },
                    };
                    if (typeof selectedProductImageData.imageData === "object") {
                        const url = process.env.REACT_APP_SERVER_PATH + `/product-images/${selectedProductImageData.id}/`;
                        await api
                            .patch(url, formData, config)
                            .then(async () => {
                                setSelectedProductImageData([]);
                                setIsLoading(false);
                                handleProductDetailsDialogue();
                            })
                            .catch((error) => {
                                setIsLoading(false);
                                handleError("error", error);
                            });
                    }
                }
            } catch (error) {
                setIsLoading(false);
                handleError("error", error);
            }
        }
        setIsLoading(false);
    };

    const submitProductMetadata = async () => {
        try {
            setLoaderMessage("Uploading");
            setIsLoading(true);
            let url;
            if (isDeodorants) {
                url = process.env.REACT_APP_SERVER_PATH + `/products/${productData.id}/`;
            } else if (isOralCare) {
                url = process.env.REACT_APP_SERVER_PATH + `/oral-care-products/${productData.id}/`;
            } else if (isSkinCleansing) {
                url = process.env.REACT_APP_SERVER_PATH + `/skin-cleansing-products/${productData.id}/`;
            } else if (isHairCare) {
                url = process.env.REACT_APP_SERVER_PATH + `/hair-care-products/${productData.id}/`;
            } else if (isSkinCare) {
                url = process.env.REACT_APP_SERVER_PATH + `/skin-care-products/${productData.id}/`;
            } else if (isUnileverFragranceHouse) {
                url = process.env.REACT_APP_SERVER_PATH + `/skin-care-products/${productData.id}/`;
            }
            await api
                .patch(url, productData)
                .then(async () => {
                    setIsLoading(false);
                    handleProductDetailsDialogue();
                })
                .catch((error) => {
                    setIsLoading(false);
                    handleError("error", error);
                });
        } catch (error) {
            setIsLoading(false);
            handleError("error", error);
        }
    };

    const handleSubmit = () => {
        submitProductImage();
        submitProductMetadata();
    };

    return (
        <>
            {isLoading && <Loader message={loaderMessage} />}
            <Dialog
                open={open}
                // onClose={handleClose}
                aria-labelledby="alert-dialog-title"
                aria-describedby="alert-dialog-description"
                maxWidth="md"
                fullWidth={true}
            >
                <DialogTitle
                    style={{
                        backgroundColor: "rgb(51, 94, 234,0.1)",
                        color: "rgb(51, 94, 234)",
                        fontSize: 15,
                        textAlign: "center",
                        padding: "10px 12px",
                    }}
                >
                    Product Details
                    {closeBtn}
                </DialogTitle>
                <DialogContent>
                    <div className="row">
                        <div
                            className="col-5 p-3"
                            style={{
                                display: "flex",
                                justifyContent: "space-between",
                                alignItems: "center",
                                flexDirection: "column",
                            }}
                        >
                            <div
                                className="product-image-container"
                                style={{
                                    margin: "auto",
                                }}
                            >
                                <ImageMagnifier src={isEdit ? selectedProductImageData.imagePath : selectedProductImage} />
                            </div>
                            <div
                                style={{
                                    display: "flex",
                                    justifyContent: "center",
                                }}
                            >
                                {isEdit ? (
                                    <Button
                                        className="custom-btn custom-btn-outlined color-blue"
                                        size="small"
                                        variant="outlined"
                                        component="label"
                                        style={{
                                            height: "31px",
                                            padding: 0,
                                        }}
                                    >
                                        <input
                                            hidden
                                            accept=".jpg,.png"
                                            type="file"
                                            onChange={(event) => handleFileChange(event)}
                                        />
                                        <span>Upload Product Image</span>
                                    </Button>
                                ) : (
                                    <Button
                                        className="custom-btn custom-btn-outlined color-blue"
                                        size="small"
                                        variant="outlined"
                                        style={{
                                            height: "31px",
                                            padding: 0,
                                        }}
                                        endIcon={<IosShareIcon />}
                                        onClick={() => {
                                            let downloadUrl = null;
                                            if (isDeodorants) {
                                                downloadUrl = process.env.REACT_APP_SERVER_PATH + `/products/export-product-info/?product_code=${encodeURIComponent(productData.product_code)}&core_data_ids=${encodeURIComponent(productData.core_data_model)}`;
                                            } else if (isOralCare) {
                                                downloadUrl = `${process.env.REACT_APP_SERVER_PATH}/oral-care-products/export-oral-care-product-info/?product_code=${encodeURIComponent(productData.product_code)}&core_data_ids=${encodeURIComponent(productData.core_data_model)}`;
                                            } else if (isSkinCleansing) {
                                                downloadUrl = `${process.env.REACT_APP_SERVER_PATH}/skin-cleansing-products/export-skin-cleansing-product-info/?product_code=${encodeURIComponent(productData.product_code)}&core_data_ids=${encodeURIComponent(productData.core_data_model)}`;
                                            } else if (isHairCare) {
                                                downloadUrl = `${process.env.REACT_APP_SERVER_PATH}/hair-care-products/export-hair-care-product-info/?product_code=${encodeURIComponent(productData.product_code)}&core_data_ids=${encodeURIComponent(productData.core_data_model)}`;
                                            } else if (isSkinCare) {
                                                downloadUrl = `${process.env.REACT_APP_SERVER_PATH}/skin-care-products/export-skin-care-product-info/?product_code=${encodeURIComponent(productData.product_code)}&core_data_ids=${encodeURIComponent(productData.core_data_model)}`;
                                            } else if (isUnileverFragranceHouse) {
                                                downloadUrl = `${process.env.REACT_APP_SERVER_PATH}/skin-care-products/export-skin-care-product-info/?product_code=${encodeURIComponent(productData.product_code)}&core_data_ids=${encodeURIComponent(productData.core_data_model)}`;
                                            }
                                            window.open(downloadUrl);
                                        }}
                                    >
                                        Export Product Information
                                    </Button>
                                )}
                            </div>
                        </div>
                        <div className="col-7 p-3">
                            <div
                                style={{
                                    height: 400,
                                    overflow: "auto",
                                }}
                            >
                                {isDeodorants && !isEdit && returnDeoData()}
                                {isOralCare && !isEdit && returnOralCareData()}
                                {isSkinCleansing && !isEdit && returnSkinCleansingData()}
                                {isHairCare && !isEdit && returnHairCareData()}
                                {isSkinCare && !isEdit && returnSkinCareData()}
                                {isUnileverFragranceHouse && !isEdit && returnUnileverFragranceHouseData()}
                                {isEdit && returnEditData()}
                            </div>
                            {isEdit && (
                                <div
                                    style={{
                                        display: "flex",
                                        justifyContent: "center",
                                        marginTop: "15px",
                                    }}
                                >
                                    <Button
                                        className="custom-btn custom-btn-outlined color-blue"
                                        size="small"
                                        variant="outlined"
                                        style={{
                                            height: "31px",
                                            padding: 0,
                                        }}
                                        onClick={handleSubmit}
                                        // disabled={true}
                                    >
                                        Update Product Metadata
                                    </Button>
                                </div>
                            )}
                        </div>
                    </div>
                </DialogContent>
            </Dialog>
        </>
    );
}

// Typechecking props for the ProductDetails
ProductDetails.propTypes = {
    open: PropTypes.bool,
    closeBtn: PropTypes.element,
    productData: PropTypes.object,
    coreDataId: PropTypes.number,
    selectedProductImage: PropTypes.string,
    selectedProductImageData: PropTypes.object,
    isEdit: PropTypes.bool,
    setSelectedProductData: PropTypes.func,
    setSelectedProductImageData: PropTypes.func,
    handleProductDetailsDialogue: PropTypes.func,
};
export default ProductDetails;
